import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output
} from "@angular/core";

@Component({
  standalone: false,
  selector: 'app-planning-draft-job-action-menu',
  templateUrl: './planning-draft-job-action-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobActionMenuComponent {
  @Input() job: any;

  @Output() onOpen = new EventEmitter<MouseEvent>();
}
